import axios from "axios";
import { ERR_TOP_CENTER } from "src/utils/snackbar-utils";
import { FS } from "../other/constance";
import { fetchNone } from "../profile-slice";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const updateAccInfo = (accountAddress, enqueueSnackbar) => async (dispatch, getState) => {
  const oldAccount = getState().accountSlice.address;
  dispatch(updateAccountAddress({ accountAddress }));
  dispatch(startFetchAccInfo());
  if (!oldAccount || accountAddress.toLowerCase() != oldAccount.toLowerCase()) {
    dispatch(fetchNone());
  }
  try {
    dispatch(fetchAccInfoSuccess({ creditScore: null, transactions: [] }));
    return Promise.resolve({ success: true });
  } catch (error) {
    console.error(error);
    dispatch(fetchAccInfoFail());
    error.response && enqueueSnackbar(JSON.stringify(error.response.data), ERR_TOP_CENTER);
    return Promise.reject(error);
  }
};

const initState = {
  address: null,
  fetchingStatus: FS.INITIAL,
  creditScore: null,
  transactions: [],
  nonce: 0,
};

const accountSlice = createSlice({
  name: "accountSlice",
  initialState: initState,
  reducers: {
    updateAccountAddress: (state, action) => {
      state.address = action.payload.accountAddress;
      //TODO: remove
      //state.address = "0xc867431efb3b775b713219ebd852e7712107ce0f";
    },
    startFetchAccInfo: (state, action) => {
      state.fetchingStatus = FS.FETCHING;
    },
    fetchAccInfoSuccess: (state, action) => {
      Object.assign(state, action.payload);
      state.fetchingStatus = FS.SUCCESS;
    },
    fetchAccInfoFail: (state, action) => {
      state.fetchingStatus = FS.FAIL;
    },
    resetAccountState: (state, action) => {
      Object.assign(state, initState);
    },
    setOpenNotify: (state, action) => {
      state.openNotify = action.payload;
    },
  },
  // extraReducers: (builder) =>
  //   builder
  //     .addCase(fetchListNotification.fulfilled, (state, action) => {
  //       state.listNotification = action.payload;
  //     })
});

export default accountSlice.reducer;
export const { updateAccountAddress, resetAccountState, fetchAccInfoSuccess, startFetchAccInfo, fetchAccInfoFail } =
  accountSlice.actions;
